import { MenuDivider, MenuHeader, MenuItem } from '@szhsin/react-menu';

import React from 'react';
import { SettingsContext } from '../../../context/context';
import { useContext } from 'react';

const ReferenceSheet = () => {
  const { state, dispatch } = useContext(SettingsContext);
  return (<>
    <MenuDivider />
    <MenuHeader>Reference Sheets</MenuHeader>
    {/* <MenuItem
      type="checkbox"
      checked={state.referenceSheet}
      onClick={e => dispatch({ type: 'referenceSheet', payload: e.checked })}>
      Reference Sheet
    </MenuItem> */}

    <MenuItem
      type="checkbox"
      checked={state.factionRules}
      onClick={e => dispatch({ type: 'factionRules', payload: e.checked })}>
      Faction Rules
    </MenuItem>

    <MenuItem
      type="checkbox"
      checked={state.coreRules}
      onClick={e => dispatch({ type: 'coreRules', payload: e.checked })}>
      Core Rules
    </MenuItem>

    <MenuItem
      type="checkbox"
      checked={state.weaponsRef}
      onClick={e => dispatch({ type: 'weaponsRef', payload: e.checked })}>
      Weapons Reference
    </MenuItem>
  </>);
};

export default ReferenceSheet;
